import { FieldProps } from 'app/frontend/base/components/form-fields/types'
import { SelectProps } from 'app/frontend/base/components/Select'
import { tileTypeToKey, useGetTileName } from './TileWrapper'
import OverviewTileType, {
  overviewTileTypes,
} from 'app/frontend/types/custom/OverviewTileType'
import SelectField from 'app/frontend/base/components/form-fields/SelectField'
import { OverviewTilePosition } from 'app/frontend/types/custom'
import { configFieldsByTileType } from '../config'
import { useFormContext, Path } from 'react-hook-form'
import { FormValues } from '..'
import { useTranslation } from 'react-i18next'

const MAIN_ONLY_TILES = ['Tile::OverviewTable', 'Tile::SidebarTiles']
const SIDEBAR_ONLY_TILES = ['Tile::RaidProgress']

type Props = {
  position: OverviewTilePosition
  configName: string
} & FieldProps<string> &
  Partial<Omit<SelectProps, 'options' | 'value'>>

const TileSelect = (props: Props) => {
  const { setValue } = useFormContext<FormValues>()
  const { t } = useTranslation()
  const getTileName = useGetTileName()

  const availableTileTypes = overviewTileTypes.filter((type) => {
    if (props.position === 'sidebar') {
      return !MAIN_ONLY_TILES.includes(type)
    }

    return !SIDEBAR_ONLY_TILES.includes(type)
  })

  return (
    <SelectField
      {...props}
      layout='stacked'
      optionLabelFn={getTileName}
      options={availableTileTypes}
      onChange={(value) => {
        const defaultConfigForNewTile =
          configFieldsByTileType[value as OverviewTileType]
            ?.flat()
            .map((config) => [config.name, config.default ?? ''])
            .concat([
              [
                'title',
                t(
                  `overview.tiles.${tileTypeToKey(
                    value as OverviewTileType,
                  )}.default-title`,
                ),
              ],
            ]) ?? []

        setValue(
          props.configName as Path<FormValues>,
          Object.fromEntries(defaultConfigForNewTile),
          { shouldDirty: true },
        )
      }}
      inModal
    />
  )
}

export default TileSelect
